module.exports = __webpack_public_path__ + "static/keyVisualBackgroundMobile-6cfb3b5eb894a96aabcda61650434855.png";